import type { FunctionComponent } from 'react'
import React from 'react'
import {
  Grid,
  GridItem,
  PageTitle,
  Picture,
  Tag,
  TypographyV2 as Typography,
} from '@which/seatbelt'

import type { Header as HeaderType } from '../../../../generated/frontend'
import styles from './Header.module.scss'

export const Header: FunctionComponent<Props> = ({
  intro,
  image,
  title,
  backgroundColour,
  tag = 'Which? Picks',
}) => (
  <Grid
    data-testid="shop-header"
    className={styles.shopHeaderContainer}
    {...(backgroundColour && { style: { backgroundColor: backgroundColour } })}
  >
    <GridItem span={{ large: 6 }} columnStart={{ large: 1 }} className={styles.shopHeaderContent}>
      <Tag text={tag} className={styles.shopHeaderTag} />
      <PageTitle pageTitle={title} pageTitleTag="h1" />
      <Typography
        className={styles.shopHeaderStandfirst}
        textStyle="sb-text-body-default-regular"
        data-testid="shop-header-standfirst"
      >
        {intro}
      </Typography>
    </GridItem>

    {image.src && (
      <GridItem
        span={{ large: 6 }}
        columnStart={{ large: 7 }}
        className={styles.shopHeaderImageContainer}
      >
        <Picture
          src={image.src}
          sources={image.sources}
          aspectRatioMain="three-to-one"
          lazyLoad={false}
        />
      </GridItem>
    )}
  </Grid>
)

///////// IMPLEMENTATION /////////

export type Props = HeaderType & { tag?: string }
